import { Box, Modal } from "@material-ui/core";
import MainButton from "components/MainApp/atoms/RoundedButton";
import iconSentEmail from "assets/images/sent-email.png";
import styles from "./SentEmailPopup.module.scss";
import i18n from "i18n";

const SentEmailPopup = ({darkMode, open, handleClose}) => {

    return (
        <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          className={darkMode ? styles["dark-modal"] : styles["white-modal"]}
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "1em",
            maxWidth: "90%",
            minWidth: "60%",
            minHeight: "30%",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "20px"
          }}
        >
          <img style={{height: "70px"}} src={iconSentEmail} alt="iconSentEmail" />
          <h3 style={{marginBottom: "5px", marginTop: "10px"}} id="simple-modal-title">{i18n.t("sent")}</h3>
          <p style={{marginBottom: "20px", marginTop: "0px"}}>{i18n.t("product.information.was.sent.successfully")}</p>

          <div className={styles["btnContainer"]}>
            <span className={styles["btnCancel"]}>
              <MainButton
                legend={i18n.t("close").toUpperCase()}
                handleClick={handleClose}
                state="enabled"
              />
            </span>
          </div>
        </Box>
      </Modal>
    )
}

export default SentEmailPopup;